import { render, staticRenderFns } from "./UpdateCustomerAccountLimitRequestPopUp.vue?vue&type=template&id=71ec5ac5&scoped=true&"
import script from "./UpdateCustomerAccountLimitRequestPopUp.vue?vue&type=script&lang=js&"
export * from "./UpdateCustomerAccountLimitRequestPopUp.vue?vue&type=script&lang=js&"
import style0 from "./UpdateCustomerAccountLimitRequestPopUp.vue?vue&type=style&index=0&id=71ec5ac5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ec5ac5",
  null
  
)

export default component.exports